export enum RecurrenceFrequency {
    Weekly = 2,
    Monthly = 3,
    Yearly = 4,
}
